<template>
  <!-- 公司管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <el-button
          class="topAn"
          type="primary"
          size="mini"
          plain
          @click="addLibrary"
        >
          <i class="el-icon-plus"></i>添加公司
        </el-button>
        <!-- 筛选 -->
        <div class="screening_box topAn">
          <el-input
            v-model="company_name"
            placeholder="请输入公司名称"
            clearable
            @change="search"
          ></el-input>
        </div>
      </div>
      <!-- 公司列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column prop="companyid" label="公司id"> </el-table-column>
          <el-table-column prop="companyname" label="公司名称">
          </el-table-column>
          <el-table-column prop="navigation" label="导航栏设置">
            <template slot-scope="scope">
              {{
                scope.row.navigation == 0
                  ? "复合型导航"
                  : scope.row.navigation == 1
                  ? "侧栏导航"
                  : "顶部导航"
              }}
            </template>
          </el-table-column>
          <el-table-column label="热敏舆情" width="120">
            <template slot-scope="scope">
              <el-popconfirm
                title="确定开通热敏舆情功能吗？"
                @confirm="addHeat(scope.row)"
                v-if="scope.row.isScheme == 'null'"
              >
                <el-button slot="reference" size="mini" round>开通</el-button>
              </el-popconfirm>
              <div v-else>
                <el-switch
                  v-model="scope.row.isScheme"
                  active-color="#525F7F"
                  active-value="1"
                  inactive-value="0"
                  @change="switchChange($event, scope.row)"
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="right" label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEmailEdit(scope.$index, scope.row)"
                >邮箱预警</el-button
              >
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <template>
                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  :hideIcon="true"
                  title="确定删除吗？"
                  @confirm="confirmDelete"
                >
                  <el-button
                    slot="reference"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
      />

      <!-- 添加/编辑公司 -->
      <el-dialog
        :title="is_add ? '添加公司' : '编辑公司'"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <!-- id -->
          <el-form-item label="公司id" prop="companyid">
            <el-input
              v-model="ruleForm.companyid"
              placeholder="请输入公司id"
              clearable
            >
              <el-button slot="append" v-if="is_add" @click="createId"
                >生成id</el-button
              >
            </el-input>
          </el-form-item>
          <!-- 名称 -->
          <el-form-item label="公司名称" prop="companyname">
            <el-input
              v-model="ruleForm.companyname"
              placeholder="请输入公司名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="导航栏布局" prop="navigation">
            <el-radio-group v-model="ruleForm.navigation">
              <el-radio :label="0">复合导航</el-radio>
              <el-radio :label="1">侧栏导航</el-radio>
              <el-radio :label="2">顶部导航</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="submitForm"
            >{{ is_add ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>

      <!-- 添加/编辑预警邮箱 -->
      <el-dialog
        :title="is_addEmail ? '添加预警邮箱' : '编辑预警邮箱'"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="emailVisible"
        @close="cancelEmail"
      >
        <el-form
          :model="emailForm"
          :rules="rules"
          ref="emailForm"
          v-load="configLoading"
        >
          <!-- 邮箱 -->
          <el-form-item label="邮箱" prop="email">
            <el-input
              v-model="emailForm.email"
              placeholder="请输入邮箱"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 邮箱授权码 -->
          <el-form-item label="邮箱授权码" prop="code">
            <el-input
              v-model="emailForm.code"
              placeholder="请输入邮箱授权码"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 邮箱服务器 -->
          <el-form-item label="邮箱服务器" prop="email_host">
            <el-select
              v-model="emailForm.email_host"
              placeholder="请选择邮箱服务器"
            >
              <el-option
                :label="item.key"
                :value="item.value"
                v-for="item in emailHostOpt"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 取数规则 -->
          <el-form-item label="取数规则" prop="time_type">
            <el-select
              v-model="emailForm.time_type"
              placeholder="请选择取数规则"
            >
              <el-option label="发表时间" :value="0" />
              <el-option label="入库时间" :value="1" />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelEmail">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="submitEmailForm"
          >
            {{ is_addEmail ? "确 定" : "保 存" }}
          </el-button>
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      btnLoading: false,
      company_name: "",
      dialogFormVisible: false,
      is_add: true,
      // 表单
      ruleForm: {
        companyname: "",
        companyid: "",
        navigation: 0
      },
      // 表单检验规则
      rules: {
        companyname: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        companyid: [
          { required: true, message: "请输入公司id", trigger: "blur" }
        ],
        navigation: [
          { required: true, message: "请选择导航栏布局类型", trigger: "blur" }
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        code: [
          { required: true, message: "请输入邮箱授权码", trigger: "blur" }
        ],
        email_host: [
          { required: true, message: "请选择邮箱服务器", trigger: "change" }
        ],
        time_type: [
          { required: true, message: "请选择取数规则", trigger: "change" }
        ]
      },
      row_index: 0,
      company_id: "",
      dialog_top: "15vh",
      is_init: false,
      is_addEmail: true,
      emailVisible: false,
      emailForm: {
        email: "",
        code: "",
        email_host: "",
        time_type: 0
      },
      emailHostOpt: [],
      emitId: "",
      configLoading: false
    };
  },
  mounted() {
    this.getEmailHost();
  },
  methods: {
    // 获取邮箱服务器
    getEmailHost() {
      if (!this.authority) return;
      this.$http({
        url: this.$api.emailHost
      }).then(res => {
        if (res.code == 0) {
          this.emailHostOpt = res.data;
          if (this.emailHostOpt.length)
            this.emailForm.email_host = this.emailHostOpt[0].value;
        }
      });
    },
    // 获取公司列表
    getList() {
      if (!this.authority) return;
      this.loading = true;
      this.tableScrollTop();
      this.$http({
        url: this.$api.companyList_page,
        data: {
          companyname: this.company_name,
          status: 1,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        this.is_init = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.concent;
          this.tableData.forEach(item => {
            item.isScheme = String(item.isScheme);
          });
        }
      });
    },
    // 新增公司
    addCompanyReq(data) {
      this.btnLoading = true;
      this.$http({
        url: this.$api.add_company,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.is_init = true;
          this.company_name = "";
          this.page = 1;
          this.getList();
          this.$hint("添加成功");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 编辑公司
    editCompanyReq(data) {
      this.btnLoading = true;
      this.$http({
        url: this.$api.edit_company,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.$set(this.tableData, this.row_index, data);
          this.$hint("保存成功");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 删除公司
    delCompanyReq() {
      this.$http({
        url: this.$api.del_company + "/" + this.company_id,
        method: "get"
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(this.row_index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 增加公司
    addLibrary() {
      this.dialogFormVisible = true;
      this.is_add = true;
      this.ruleForm = {
        companyname: "",
        companyid: "",
        navigation: 0
      };
    },
    // 编辑公司
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.is_add = false;
      this.row_index = index;
      this.ruleForm = JSON.parse(JSON.stringify(row));
    },
    // 点击编辑邮箱预警
    handleEmailEdit(index, row) {
      this.emailVisible = true;
      this.is_addEmail = true;
      this.row_index = index;
      this.company_id = row.companyid;
      this.emitId = "";
      // 获取邮箱配置
      this.configLoading = true;
      this.$http({
        url: this.$api.selectOne,
        data: {
          company_id: row.companyid
        }
      })
        .then(res => {
          this.configLoading = false;
          if (res.code == 0) {
            if (res.data.length) {
              this.is_addEmail = false;
              this.emailForm.email = res.data[0].email;
              this.emailForm.code = res.data[0].code;
              this.emailForm.email_host = res.data[0].email_host;
              this.emailForm.time_type = res.data[0].time_type;
              this.emitId = res.data[0].id;
            }
          } else {
            this.$hint(res.message, "err");
          }
        })
        .catch(err => {
          this.configLoading = false;
          this.$hint(err, "err");
        });
    },
    // 点击删除公司
    handleDelete(index, row) {
      this.company_id = row.id;
      this.row_index = index;
    },
    // 确定删除公司
    confirmDelete() {
      this.delCompanyReq();
    },
    // 确定新增、编辑
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let item = JSON.parse(JSON.stringify(this.ruleForm));
          if (this.is_add) {
            // 新增
            this.addCompanyReq(item);
          } else {
            // 编辑
            this.editCompanyReq(item);
          }
          this.cancel();
        } else {
          return false;
        }
      });
    },
    // 确定新增、编辑预警邮箱
    submitEmailForm() {
      this.$refs.emailForm.validate(valid => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.emailForm));
          data.company_id = this.company_id;
          if (!this.is_addEmail) data.id = this.emitId;
          this.$http({
            url: this.$api.saveOrEdit,
            data
          })
            .then(res => {
              if (res.code == 0) {
                this.$hint("配置成功!");
                this.cancelEmail();
              } else {
                this.$hint(res.message, "err");
              }
            })
            .catch(err => {
              this.$hint(err, "err");
            });
        } else {
          return false;
        }
      });
    },
    // 生成id
    createId() {
      let $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      let maxPos = $chars.length;
      let id = "";
      for (var i = 0; i < 32; i++) {
        id += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      this.$set(this.ruleForm, "companyid", id.toLowerCase());
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    // 点击取消邮箱预警
    cancelEmail() {
      this.emailVisible = false;
      this.$refs.emailForm.resetFields();
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList();
    },
    // 开通热敏舆情权限
    addHeat(row) {
      this.$http({
        url: this.$api.open_heat,
        data: {
          companyId: row.companyid,
          isScheme: 1
        }
      }).then(res => {
        if (res.code == 0) {
          row.isScheme = "1";
          this.$hint("开通成功！");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 开启/关闭热敏舆情权限
    switchChange(isScheme, row) {
      this.$http({
        url: this.$api.edit_heat,
        data: {
          id: row.childId,
          companyId: row.id,
          isScheme
        }
      })
        .then(res => {
          if (res.code == 0) {
            isScheme == 1 ? this.$hint("已开启！") : this.$hint("已关闭！");
          } else {
            isScheme == 1 ? (row.isScheme = "0") : (row.isScheme = "1");
            this.$hint(res.message, "err");
          }
        })
        .catch(err => {
          isScheme == 1 ? (row.isScheme = "0") : (row.isScheme = "1");
          this.$hint("操作失败", "err");
        });
    }
  }
};
</script>

<style></style>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/index/views/companyList.vue